import { render, staticRenderFns } from "./studentL.vue?vue&type=template&id=7894201e&scoped=true&"
import script from "./studentL.vue?vue&type=script&lang=js&"
export * from "./studentL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7894201e",
  null
  
)

export default component.exports